import { DeleteOutlined } from '@ant-design/icons';
import { Form, Input, Select } from 'antd';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { emailFormatRule } from 'app/utils/rules';

import { FieldValue } from '../FieldView/FieldView';

import styles from './SpacesContacts.module.scss';
import { SPACES_CONTACTS_FIELD, isDuplicateSpaceEmail } from './columns';
import type { SpaceContact, SpaceOption } from './columns';

type SpaceContactCardProps = {
  isEditMode: boolean;
  displayIndex: number;
  namePath: number;
  contact?: SpaceContact;
  spaceOptions: SpaceOption[];
  spaceLabelById: Record<number, string>;
  onRemove?: () => void;
  canRemove: boolean;
};

export const SpaceContactCard = ({
  isEditMode,
  displayIndex,
  namePath,
  contact,
  spaceOptions,
  spaceLabelById,
  onRemove,
  canRemove,
}: SpaceContactCardProps) => (
  <div className={styles.card}>
    <div className={styles.cardHeader}>
      <div className={styles.cardTitle}>
        Contact by space #{displayIndex + 1}
      </div>
      {canRemove && (
        <DeleteOutlined className={styles.deleteIcon} onClick={onRemove} />
      )}
    </div>

    <FormLineLayout label="Space" isRequired isInModal>
      <Form.Item
        name={isEditMode ? [namePath, 'spaceId'] : undefined}
        rules={
          isEditMode
            ? [{ required: true, message: 'Space is required' }]
            : undefined
        }
      >
        {isEditMode ? (
          <Select
            placeholder="Select a space"
            options={spaceOptions}
            optionFilterProp="label"
            showSearch
          />
        ) : (
          <FieldValue
            value={
              contact?.spaceId !== undefined
                ? spaceLabelById[contact.spaceId]
                : undefined
            }
            emptyText="∅ empty"
          />
        )}
      </Form.Item>
    </FormLineLayout>

    <FormLineLayout label="Email" isRequired isInModal>
      <Form.Item
        name={[namePath, 'email']}
        dependencies={isEditMode ? [[SPACES_CONTACTS_FIELD]] : undefined}
        rules={
          isEditMode
            ? [
                { required: true, message: 'Email is required' },
                emailFormatRule,
                ({ getFieldValue }) => ({
                  validator: async () => {
                    if (
                      isDuplicateSpaceEmail(
                        getFieldValue(SPACES_CONTACTS_FIELD),
                        namePath
                      )
                    ) {
                      throw new Error(
                        'This email address is already associated with this space.'
                      );
                    }
                  },
                }),
              ]
            : undefined
        }
      >
        {isEditMode ? (
          <Input type="email" />
        ) : (
          <FieldValue value={contact?.email} emptyText="∅ empty" />
        )}
      </Form.Item>
    </FormLineLayout>

    <FormLineLayout label="Direct phone" isInModal>
      <Form.Item name={[namePath, 'phone']}>
        {isEditMode ? (
          <Input />
        ) : (
          <FieldValue value={contact?.phone} emptyText="∅ empty" />
        )}
      </Form.Item>
    </FormLineLayout>
  </div>
);
